module.exports = __webpack_public_path__ + "static/media/Boy.546c9fac.png";